import { Table } from "react-bootstrap";
import { Case } from "../../../../models";
import { ReferralSummary } from ".";

interface ReferralSummaryListProps {
    cases: Case[];
    onClick: (_case: Case) => void;
}

export function ReferralSummaryList({ cases, onClick }: Readonly<ReferralSummaryListProps>) {
    return (
        <Table striped hover>
            <tbody>
                {cases.map((_case) => (
                    <tr key={_case.id} onClick={() => onClick(_case)} className="clickable">
                        <td>
                            <ReferralSummary case={_case} />
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
}
